module.exports = __webpack_public_path__ + "img/first.fd90d624.svg";